import React from 'react';
// import { createSelector } from '@reduxjs/toolkit';
// import { connect } from 'react-redux';
import { FormField } from './FormField';
// import AddField from './AddField'
import { makeStyles, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {},
  },
  paper: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

export const FormFields = ({ fields, formId }) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.root}>
        {fields.length === 0 && (
          <Paper className={classes.paper}>
            <h3>Please, start to add fields!</h3>
          </Paper>
        )}
        {fields !== 'not_initialized' &&
          fields.map((field) => (
            <FormField field={field} key={field.fieldId} formId={formId} />
          ))}
      </div>
      {/* <AddField /> */}
    </div>
  );
};

// const selectFormFields = (state, ownProps) => {
//   return state.formFields[ownProps.formId] || [];
// };

// const selectSortedFields = createSelector([selectFormFields], (fields) => {
//   return fields.slice().sort((a, b) => a.idx - b.idx);
// });

// const mapStateToProps = (state, ownProps) => ({
//   fields: selectSortedFields(state, ownProps),
// });

// export default connect(mapStateToProps)(FormFields);
